// extracted by mini-css-extract-plugin
export default {"logo":"LogoDark_logo__32jYI"};